import React, { useState } from "react";
import { HashLink } from "react-router-hash-link";
import Fade from "react-reveal/Fade";
import User from "../individual/User";
import { BsThreeDots } from "react-icons/bs";
import useAuth from "../../Hooks/useAuth";

const DiscoverItem = ({ data }) => {
  const [showOption, setShowOption] = useState(false);
  const { showDummyImage } = useAuth();
  return (
    <Fade bottom duration={1000}>
      <div className="discover-item">
        <div className="discover-item-top">
          <div className="discover-user">
            <div className="user-img-container">
              <User
                pic={require(`${process.env.REACT_APP_USER_IMAGE}${data?.profileImg}`)}
                status={data?.status}
                id={data?.id}
                showDummyImage={showDummyImage}
                resulution={"40X40"}
              />
            </div>
            <h6 className="discover-user-name">{data?.profileName}</h6>
          </div>
          <div className="discover-options">
            <button
              className="discover-options-btn"
              onClick={() => setShowOption(!showOption)}
            >
              <BsThreeDots />
            </button>
            <div
              className={`discover-option ${showOption ? "show-option" : " "}`}
              onMouseLeave={() => setShowOption(false)}
            >
              <ul>
                {Array.from({ length: 3 }).map((_, i) => (
                  <li key={i} onClick={() => setShowOption(false)}>
                    Option-1
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <figure>
          <HashLink to={`/product/${data?.id}#header`}>
            <div className="product-img">
              {data?.image.length < 50 ? (
                <img
                  src={require(`${process.env.REACT_APP_DISCOVER_IMAGE}${data?.image}`)}
                  alt={data?.id}
                  onError={({ currentTarget }, imageSize = "240X195") =>
                    showDummyImage({ currentTarget }, imageSize)
                  }
                />
              ) : (
                <img
                  src={data?.image}
                  alt={data?.id}
                  onError={({ currentTarget }, imageSize = "240X195") =>
                    showDummyImage({ currentTarget }, imageSize)
                  }
                />
              )}
            </div>
          </HashLink>
          <figcaption>
            <div className="count-down">
              <p>{data?.timeline}</p>
            </div>
            <div className="discover-item-title">
              <h4>{data?.title}</h4>
              <span>1/1</span>
            </div>
            <small className="highet-bid">{data?.category}</small>
            <div className="price-and-btn">
              <span className="discover-item-price">
                Bid {data?.price} {data?.currency}
              </span>
              <HashLink to={"/connectwallet/#header"} className="place-a-bid">
                Place a Bid
              </HashLink>
            </div>
          </figcaption>
        </figure>
      </div>
    </Fade>
  );
};

export default DiscoverItem;
